export default function getResource(label, vars = []) {
    const resources = {
        shadeFinderTitle: 'Trouver votre teinte'
    };

    return resources[label];
}
